var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"sizeMarker",attrs:{"src":require("@/assets/img/pin-green.png"),"alt":"","srcset":""}})])
}]

export { render, staticRenderFns }